import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Media, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';
import moment from 'moment';

import styles from './ConsignmentDocuments.module.css';

function ConsignmentDocument(props) {

    var imageUrl = `api/document/${props.document.id}/image`;
    
    return (
        <React.Fragment>
            <Media>
                <Media left href={`${imageUrl}`}>
                    <Media className={styles.img} object src={imageUrl} alt="" />
                </Media>
                <Media body>
                    <Media heading>
                        {props.document.description}
                    </Media>
                    <p>
                        Date Added: {moment(props.document.docDate).format('YYYY-MM-DD')}
                    </p>
                </Media>
            </Media>
        </React.Fragment>
        );
}

function ConsignmentDocuments(props) {

    let history = useHistory();
    let { consignmentId } = useParams();

    const [documents, setDocuments] = useState([]);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setBusy(true);
        fetch(`api/consignments/${consignmentId}/documents`,
            {
                credentials: 'include'
            })
            .then(handleResponse)
            .then(data => {
                setDocuments(data);
                setBusy(false);
            })
            .catch(error => {

            });

    }, [consignmentId]);

    return busy ?
        <BusyIndicator isBusy={busy} /> : (
        <div>
            {
                documents && documents.map((doc, index) => <ConsignmentDocument key={`doc_${index}`} document={doc} />)
            }
            <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}/new-document`)} block>Add</Button>
                <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}`)} block>Back</Button>
        </div>
    );
}

export { ConsignmentDocuments };